/**
 * DoctrineBanner.js — compact single-source-of-truth ribbon.
 *
 * Renders the server-published firm doctrine line + resilient pipeline
 * status. This is how field surfaces (ExpoLive, FieldMode) and the
 * Owner Executive Brief prove the doctrine is live and server-driven,
 * not hardcoded per-view. If doctrine hasn't loaded yet, renders null
 * so nothing shifts on the page.
 */
import React from "react";
import { useDoctrine } from "../hooks/useDoctrine";

const CYAN = "#00CFCF";
const CHROME = "#A0A0A0";
const INK = "#F5F5F7";

const wrap = {
  background: "rgba(0,0,0,0.35)",
  border: `1px solid ${CYAN}33`,
  borderRadius: 8,
  padding: "8px 12px",
  marginBottom: 10,
  fontSize: 11,
  color: INK,
  lineHeight: 1.4,
};

const label = {
  fontSize: 9,
  letterSpacing: "0.2em",
  color: CYAN,
  fontWeight: 800,
  marginBottom: 3,
};

const meta = {
  fontSize: 10,
  color: CHROME,
  marginTop: 3,
};

export default function DoctrineBanner({ compact = false }) {
  const { firm, directive, loaded } = useDoctrine();
  if (!loaded || !firm?.doctrine) return null;
  return (
    <div style={wrap} data-testid="doctrine-banner">
      <div style={label}>SERVER-DRIVEN DOCTRINE · v {directive?.directive_version || ""}</div>
      <div>{firm.doctrine}</div>
      {!compact && directive?.doctrine && (
        <div style={meta} data-testid="doctrine-banner-line">{directive.doctrine}</div>
      )}
    </div>
  );
}
